import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { Folder,UserDetails } from "./folder-model";
@Injectable({
  providedIn: "root",
})
export class SharedDataService {
  constructor() {}

  private userDetailsSubject = new BehaviorSubject<UserDetails | null>(null);
  userDetails$ = this.userDetailsSubject.asObservable();

  private formDataSubject = new BehaviorSubject<any>(null);
  formData$ = this.formDataSubject.asObservable();

  // private dataSourceSubject: BehaviorSubject<any[]> = new BehaviorSubject<
  //   any[]
  // >([]);
  // public dataSource$: Observable<any[]> = this.dataSourceSubject.asObservable();

  private dataSourceSubject: BehaviorSubject<Folder[]> = new BehaviorSubject<
    Folder[]
  >([]);
  public dataSource$: Observable<Folder[]> =
    this.dataSourceSubject.asObservable();

  private newFolderSubject: BehaviorSubject<Folder | null> =
    new BehaviorSubject(null);
  newFolder$: Observable<Folder | null> = this.newFolderSubject.asObservable();

  // Method to update the shared data
  updateFormData(data: any) {
    this.formDataSubject.next(data);
  }

  appendDataSource(newItem: any) {
    const currentData = this.dataSourceSubject.getValue();
    const updatedData = [...currentData, newItem];
    this.dataSourceSubject.next(updatedData);
  }

  getDataSource(): Observable<any[]> {
    return this.dataSource$;
  }

  setNewFolder(folder: Folder) {
    this.newFolderSubject.next(folder);
  }

  setUserDetails(details: UserDetails) {
    this.userDetailsSubject.next(details);
  }
  getUserDetails(): UserDetails | null {
    return this.userDetailsSubject.value;
  }
}
